export default __webpack_public_path__ + "static/media/Hero SVGheroimg2.c4ee2c1f.png";